import { render, staticRenderFns } from "./USADDTTest.vue?vue&type=template&id=27abb385&"
import script from "./USADDTTest.vue?vue&type=script&lang=js&"
export * from "./USADDTTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports